import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import CustomLink from "./CustomLink";
import { serverURL } from "./networking";

export default function Navbar() {
    const navigate = useNavigate();

    function logout() {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );

        axios
            .post(
                serverURL + "/api/user/logout/",
                {},
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                sessionStorage.removeItem("user_id");
                navigate("/");
            })
            .catch(function (error) {
                console.log(error.response);
                sessionStorage.removeItem("user_id");
                navigate("/");
            });
    }

    return (
        <nav className="nav">
            <Link to="/home" className="site-title">
                <img src="/korotuIconWhite.svg" alt="Korotu Tech. Icon" />
                <div>
                    <p>Korotu </p>
                    <h1>CarbonCruise</h1>
                </div>
            </Link>
            <ul>
                <li>
                    <a
                        href="https://drive.google.com/file/d/1X7IWnePetxARAafaopQJ78D7K5hgAEkL/view?usp=sharing"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        User Guide
                    </a>
                </li>
                <CustomLink to="/home/reports">Reports</CustomLink>
                <CustomLink to="/home/upload">Upload</CustomLink>
                <CustomLink onClick={logout}>Log out</CustomLink>
            </ul>
        </nav>
    );
}
